import React from 'react';
import Icon from 'components/AppIcon';

const ClientFilters = ({ selectedFilters, onFiltersChange }) => {
  const kenyanCounties = [
    'Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Kiambu', 'Machakos', 'Meru',
    'Nyeri', 'Thika', 'Garissa', 'Kakamega', 'Malindi', 'Kitale', 'Embu', 'Kericho',
    'Migori', 'Bungoma', 'Homa Bay', 'Naivasha', 'Voi', 'Wajir', 'Marsabit', 'Isiolo',
    'Maralal', 'Kapenguria', 'Moyale', 'Mandera', 'Lodwar', 'Kabarnet', 'Kerugoya',
    'Murang\'a', 'Nyahururu', 'Nanyuki', 'Makindu', 'Wote', 'Kitui', 'Mwingi', 'Mutomo',
    'Kibwezi', 'Taveta', 'Lamu', 'Kilifi', 'Kwale', 'Msambweni', 'Ukunda'
  ];

  const caseCategories = [
    'Criminal Law', 'Family Law', 'Corporate Law', 'Contract Law', 'Property Law',
    'Employment Law', 'Maritime Law', 'Constitutional Law', 'Tax Law', 'Immigration Law',
    'Intellectual Property', 'Environmental Law', 'Banking Law', 'Insurance Law'
  ];

  const handleFilterChange = (filterType, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Client Type Filter */}
      <div className="min-w-0 flex-shrink-0">
        <select
          value={selectedFilters.clientType}
          onChange={(e) => handleFilterChange('clientType', e.target.value)}
          className="w-full sm:w-auto px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-surface"
        >
          <option value="all">All Types</option>
          <option value="individual">Individual</option>
          <option value="corporate">Corporate</option>
        </select>
      </div>

      {/* County Filter */}
      <div className="min-w-0 flex-shrink-0">
        <select
          value={selectedFilters.county}
          onChange={(e) => handleFilterChange('county', e.target.value)}
          className="w-full sm:w-auto px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-surface"
        >
          <option value="all">All Counties</option>
          {kenyanCounties.map(county => (
            <option key={county} value={county}>{county}</option>
          ))}
        </select>
      </div>

      {/* Case Category Filter */}
      <div className="min-w-0 flex-shrink-0">
        <select
          value={selectedFilters.caseCategory}
          onChange={(e) => handleFilterChange('caseCategory', e.target.value)}
          className="w-full sm:w-auto px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-surface"
        >
          <option value="all">All Categories</option>
          {caseCategories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>

      {/* Relationship Status Filter */}
      <div className="min-w-0 flex-shrink-0">
        <select
          value={selectedFilters.relationshipStatus}
          onChange={(e) => handleFilterChange('relationshipStatus', e.target.value)}
          className="w-full sm:w-auto px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-surface"
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {/* Clear Filters */}
      <button
        onClick={() => onFiltersChange({
          clientType: 'all',
          county: 'all',
          caseCategory: 'all',
          relationshipStatus: 'all'
        })}
        className="flex items-center gap-2 px-3 py-2 text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-lg transition-smooth focus:outline-none focus:ring-2 focus:ring-secondary-400"
        title="Clear all filters"
      >
        <Icon name="X" size={16} />
        <span className="hidden sm:inline">Clear</span>
      </button>
    </div>
  );
};

export default ClientFilters;